export default [
  'deviceTypeName',
];

// used when enum is not fetched
export const DEFAULT_ENUM = [
  {
    text: 'Value1',
    value: 0,
  },
  {
    text: 'Value2',
    value: 1,
  },
  {
    text: 'Value3',
    value: 2,
  },
  {
    text: 'Value4',
    value: 3,
  },
];

export const beltStartMode = [
  {
    value: 1,
    text: 'Start the belt when you start weighing the last material on that scale',
  }, {
    value: 2,
    text: 'Start the belt before the delay of that scale',
  }, {
    value: 3,
    text: 'Start the belt when the scale begins Discharge',
  }, {
    value: 4,
    text: 'Start as soon as all the material for that scale are finished weighing up',
  },
];

export const scaleGraduation = [
  {
    value: 1,
    text: '1',
  },
  {
    value: 2,
    text: '2',
  },
  {
    value: 5,
    text: '5',
  },
  {
    value: 10,
    text: '10',
  },
  {
    value: 20,
    text: '20',
  },
  {
    value: 50,
    text: '50',
  },
];

export const screwMode = [
  {
    value: 1,
    text: 'BATCHER SCREW',
  },
];

export const wetDryMode = [
  {
    value: 1,
    text: 'NO',
  },
  {
    value: 2,
    text: 'NC',
  },
];

export enum MixerType {
  Central = 'Central',
  Stationary = 'Stationary',
  ForwardReverse = 'ForwardReverse',
  HrmAstec = 'HrmAstec',
}

export enum MixingStartPoint {
  OnFirstMaterialLoaded = 'OnFirstMaterialLoaded',
  OnAllMaterialsLoaded = 'OnAllMaterialsLoaded',
}

export enum IconDirection {
  Left = 'Left',
  Right = 'Right',
}

export const DeviceTypeEnum = {
  beltStartMode,
  MixerType,
  scaleGraduation,
  screwMode,
  wetDryMode,
};
